/* eslint-disable */
// @ts-nocheck
import type { ApiRequestOptions, ApiErrorWithHeadersAndBody, ApiResult, IServiceInstanceOptions, ValidateResponse } from './types';
import type { GetCryptoPaymentServiceInfoResponse, GetPaymentServiceBankDetailsResponse, GetPaymentServiceInfoResponse, GetPaymentMetaInfoResponse, GetWidgetResponse, GetPaycomTokenizationSessionResponse, AcceptPaymentTermResponse, GetAcceptedPaymentTermsResponse, RegisterPaymentUserAccountResponse, ConfirmPaymentUserAccountResponse, LinkBankAccountResponse, CreateNewMethodResponse, GetAeropayStatusResponse, Capture3DsPaymentResponse, GetOffersResponse, UpdateInboxNotificationResponse, GetInboxNotificationsResponse, CreateAccountPaymentMethodResponse, CreatePayperPaymentMethodResponse, GetPaymentMethodsResponse, GetIframeSecurityDataResponse, DeletePaymentMethodResponse, CreateOrderResponse, ConfirmOrderResponse, RefreshOrderResponse, GetPaymentOrderResponse, GetWithdrawMethodsResponse, CaptureRedeemOptionResponse, RedeemMoneyResponse, CancelRedeemMoneyResponse, CancelAllRedeemMoneyResponse, GetRedeemMoneyHistoryResponse, GetRedeemHistoryResponse, GetWithdrawSettingsResponse, GetPendingRedeemCountResponse, GetCurrencyRateResponse, ValidateApplePayMerchantResponse, TokenizeApplePayResponse, TokenizeGooglePayResponse, GetPurchaseHistoryResponse, GetRedeemsRequestResponse, GetTransactionLimitRequestResponse, SetPurchaseLimitRequestResponse, GetPurchaseLimitRequestResponse, ResetPaymentMethodsRequestResponse, ResetPurchaseLimitRequestResponse } from './client/types.gen';
import { createExtensions } from './extensions';
import { getHMACHeaders, getEncryptedHeader, decodeResponse } from './core/patriannaRequest';
import { createClient } from './client/client';
import {
  getCryptoPaymentServiceInfo,
  getPaymentServiceBankDetails,
  getPaymentServiceInfo,
  getPaymentMetaInfo,
  getWidget,
  getPaycomTokenizationSession,
  acceptPaymentTerm,
  getAcceptedPaymentTerms,
  registerPaymentUserAccount,
  confirmPaymentUserAccount,
  linkBankAccount,
  createNewMethod,
  getAeropayStatus,
  capture3DsPayment,
  getOffers,
  updateInboxNotification,
  getInboxNotifications,
  createAccountPaymentMethod,
  createPayperPaymentMethod,
  getPaymentMethods,
  getIframeSecurityData,
  deletePaymentMethod,
  createOrder,
  confirmOrder,
  refreshOrder,
  getPaymentOrder,
  getWithdrawMethods,
  captureRedeemOption,
  redeemMoney,
  cancelRedeemMoney,
  cancelAllRedeemMoney,
  getRedeemMoneyHistory,
  getRedeemHistory,
  getWithdrawSettings,
  getPendingRedeemCount,
  getCurrencyRate,
  validateApplePayMerchant,
  tokenizeApplePay,
  tokenizeGooglePay,
  getPurchaseHistory,
  getRedeemsRequest,
  getTransactionLimitRequest,
  setPurchaseLimitRequest,
  getPurchaseLimitRequest,
  resetPaymentMethodsRequest,
  resetPurchaseLimitRequest,
} from './client/sdk.gen';

export enum Definition {
  X_MESSAGE_ID = 'xMessageId',
  X_TIMESTAMP = 'xTimestamp',
  BRAND_NAME = 'brandName',
  PLATFORM = 'platform',
  REQUEST_BODY = 'requestBody',
  X_CHK = 'xChk',
}

/** Maps our extension names to spec parameter location. Used under the hook for per-operation injection. */
const EXTENSION_SPEC: Record<string, { in: 'header' | 'query'; name: string }> = {
  xMessageId: { in: 'header', name: 'X-Message-Id' },
  xTimestamp: { in: 'header', name: 'X-Timestamp' },
  brandName: { in: 'query', name: 'brandName' },
  platform: { in: 'query', name: 'platform' },
  xChk: { in: 'query', name: 'xChk' },
};

const OPERATION_PARAMS: Record<string, { headers: string[]; query: string[] }> = {
  'cryptoNetwork': { headers: [], query: [] },
  'cryptoCurrency': { headers: [], query: [] },
  'cryptoPurchase': { headers: [], query: [] },
  'scaAuthenticate': { headers: [], query: [] },
  'card': { headers: [], query: [] },
  'getCryptoPaymentServiceInfo': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPaymentServiceBankDetails': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPaymentServiceInfo': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPaymentMetaInfo': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getWidget': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPaycomTokenizationSession': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'acceptPaymentTerm': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getAcceptedPaymentTerms': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'registerPaymentUserAccount': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'confirmPaymentUserAccount': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'linkBankAccount': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'createNewMethod': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getAeropayStatus': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'capture3DsPayment': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getOffers': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'updateInboxNotification': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getInboxNotifications': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'createAccountPaymentMethod': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'createPayperPaymentMethod': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPaymentMethods': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getIframeSecurityData': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'deletePaymentMethod': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'createOrder': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'confirmOrder': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'refreshOrder': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPaymentOrder': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getWithdrawMethods': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'captureRedeemOption': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'redeemMoney': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'cancelRedeemMoney': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'cancelAllRedeemMoney': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getRedeemMoneyHistory': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getRedeemHistory': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getWithdrawSettings': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPendingRedeemCount': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getCurrencyRate': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'validateApplePayMerchant': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'tokenizeApplePay': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'tokenizeGooglePay': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPurchaseHistory': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getRedeemsRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getTransactionLimitRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'setPurchaseLimitRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'getPurchaseLimitRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'resetPaymentMethodsRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
  'resetPurchaseLimitRequest': { headers: ['X-Message-Id', 'X-Timestamp'], query: ['brandName', 'platform'] },
};

/** Creates a fetch that uses mTLS (key + cert). For server-side only. Uses Node's built-in fetch with undici Agent (bundled in Node 18+). Loaded dynamically so the client can run in browser when mTLS is not used. */
const createMtlsFetch = (key: string | Buffer, cert: string | Buffer) => {
  const { Agent } = require('undici') as typeof import('undici');
  const dispatcher = new Agent({
    connect: { key, cert, rejectUnauthorized: true },
  });
  return (request: Request): Promise<Response> =>
    fetch(request.url, {
      method: request.method,
      headers: request.headers,
      body: request.body,
      credentials: 'include',
      dispatcher,
    } as RequestInit);
};

export const createApiClient = (options: IServiceInstanceOptions) => {
  const useMtls = options.mtlsKey != null && options.mtlsCert != null;
  const client = createClient({
    baseUrl: options.url,
    credentials: 'include',
    ...(useMtls ? { fetch: createMtlsFetch(options.mtlsKey!, options.mtlsCert!) } : {}),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json, text/plain, */*',
      'X-Platform': typeof options.platform === 'string' ? options.platform : 'web',
      'X-Brand': options.brandName,
      ...(options.userAgent ? { 'user-agent': options.userAgent } : {}),
      ...(options.headers || {}),
    },
  });

  const urlSigningKey = options.urlSigningKey ?? options.urlSigningsKey;
  const encryptedMethods = options.encryptedMethods ?? [];

  client.interceptors.request.use(async (request: Request) => {
    const url = request.url;
    const hmac = getHMACHeaders(url, urlSigningKey, options.url);
    const encrypted = getEncryptedHeader(url, encryptedMethods);
    const headers = new Headers(request.headers);
    Object.entries(hmac).forEach(([k, v]) => headers.set(k, v));
    Object.entries(encrypted).forEach(([k, v]) => headers.set(k, v));
    return new Request(request, { headers, credentials: request.credentials });
  });

  client.interceptors.response.use(async (response: Response) => {
    if (!response.headers.get('X-Payload-Var')) return response;
    try {
      const data = await decodeResponse(response);
      const body = JSON.stringify(data);
      const headers = new Headers(response.headers);
      headers.set('Content-Type', 'application/json');
      headers.set('Content-Length', String(new TextEncoder().encode(body).length));
      return new Response(body, {
        status: response.status,
        statusText: response.statusText,
        headers,
      });
    } catch (e) {
      throw e;
    }
  });

  const extensions = createExtensions(options);

  const resolveExtensionValues = async (opId: string) => {
    const params = OPERATION_PARAMS[opId] ?? { headers: [], query: [] };
    const headers: Record<string, string> = {};
    const query: Record<string, string> = {};
    for (const [extName, spec] of Object.entries(EXTENSION_SPEC)) {
      const data = await Promise.resolve(extensions[extName]?.getData());
      const value = data != null ? String(data) : undefined;
      if (value === undefined) continue;
      if (spec.in === 'header' && params.headers.includes(spec.name)) {
        headers[spec.name] = value;
      }
      if (spec.in === 'query' && params.query.includes(spec.name)) {
        query[spec.name] = value;
      }
    }
    return { headers, query };
  };

  const buildRequestOpts = <TBody>(
    extHeaders: Record<string, string>,
    extQuery: Record<string, string>,
    requestBody: TBody,
    requestOptions?: ApiRequestOptions,
  ) => {
    const headers = { ...extHeaders, ...(requestOptions?.headers ?? {}) };
    const query = { ...extQuery, ...(requestOptions?.query ?? {}) };
    const { method: _method, responseStyle: _responseStyle, ...restOptions } = requestOptions ?? {};
    return { client, body: requestBody, responseStyle: 'fields' as const, ...restOptions, headers, query };
  };

  /** Returns data by default; returns { data, request, response } when options.responseStyle === 'full'. */
  const mapResponse = <T, O extends ApiRequestOptions | undefined>(
    result: { data: T; request: Request; response: Response },
    options?: O,
  ): ApiResult<T, O> =>
    (options?.responseStyle === 'full' ? result : result.data) as ApiResult<T, O>;

  /** When responseStyle !== 'full', throw on non-OK so callers get ApiErrorWithHeadersAndBody. When 'full', do not throw. */
  const maybeThrowOnError = (
    result: { data?: unknown; error?: unknown; request: Request; response: Response },
    responseStyle?: 'data' | 'full',
  ): void => {
    if (responseStyle === 'full' || result.response.ok) return;
    const raw = result.error ?? result.data;
    const body = typeof raw === 'object' && raw !== null
      ? { ...(raw as Record<string, unknown>) }
      : { errorText: raw != null ? String(raw) : undefined };
    const err = new Error(result.response.statusText || `HTTP ${result.response.status}`) as ApiErrorWithHeadersAndBody<unknown>;
    err.name = 'ApiError';
    err.request = result.request;
    err.response = result.response;
    err.headers = result.response.headers;
    err.body = body as ApiErrorWithHeadersAndBody['body'];
    err.statusText = result.response.statusText;
    throw err;
  };

  return {
    getCryptoPaymentServiceInfo: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getCryptoPaymentServiceInfo>[0]['body'], requestOptions?: O): Promise<ApiResult<GetCryptoPaymentServiceInfoResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getCryptoPaymentServiceInfo');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getCryptoPaymentServiceInfo(opts as Parameters<typeof getCryptoPaymentServiceInfo>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetCryptoPaymentServiceInfoResponse, O>;
    },
    getPaymentServiceBankDetails: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPaymentServiceBankDetails>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPaymentServiceBankDetailsResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPaymentServiceBankDetails');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPaymentServiceBankDetails(opts as Parameters<typeof getPaymentServiceBankDetails>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPaymentServiceBankDetailsResponse, O>;
    },
    getPaymentServiceInfo: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPaymentServiceInfo>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPaymentServiceInfoResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPaymentServiceInfo');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPaymentServiceInfo(opts as Parameters<typeof getPaymentServiceInfo>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPaymentServiceInfoResponse, O>;
    },
    getPaymentMetaInfo: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPaymentMetaInfo>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPaymentMetaInfoResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPaymentMetaInfo');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPaymentMetaInfo(opts as Parameters<typeof getPaymentMetaInfo>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPaymentMetaInfoResponse, O>;
    },
    getWidget: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getWidget>[0]['body'], requestOptions?: O): Promise<ApiResult<GetWidgetResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getWidget');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getWidget(opts as Parameters<typeof getWidget>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetWidgetResponse, O>;
    },
    getPaycomTokenizationSession: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPaycomTokenizationSession>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPaycomTokenizationSessionResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPaycomTokenizationSession');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPaycomTokenizationSession(opts as Parameters<typeof getPaycomTokenizationSession>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPaycomTokenizationSessionResponse, O>;
    },
    acceptPaymentTerm: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof acceptPaymentTerm>[0]['body'], requestOptions?: O): Promise<ApiResult<AcceptPaymentTermResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('acceptPaymentTerm');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await acceptPaymentTerm(opts as Parameters<typeof acceptPaymentTerm>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<AcceptPaymentTermResponse, O>;
    },
    getAcceptedPaymentTerms: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getAcceptedPaymentTerms>[0]['body'], requestOptions?: O): Promise<ApiResult<GetAcceptedPaymentTermsResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getAcceptedPaymentTerms');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getAcceptedPaymentTerms(opts as Parameters<typeof getAcceptedPaymentTerms>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetAcceptedPaymentTermsResponse, O>;
    },
    registerPaymentUserAccount: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof registerPaymentUserAccount>[0]['body'], requestOptions?: O): Promise<ApiResult<RegisterPaymentUserAccountResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('registerPaymentUserAccount');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await registerPaymentUserAccount(opts as Parameters<typeof registerPaymentUserAccount>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<RegisterPaymentUserAccountResponse, O>;
    },
    confirmPaymentUserAccount: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof confirmPaymentUserAccount>[0]['body'], requestOptions?: O): Promise<ApiResult<ConfirmPaymentUserAccountResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('confirmPaymentUserAccount');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await confirmPaymentUserAccount(opts as Parameters<typeof confirmPaymentUserAccount>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<ConfirmPaymentUserAccountResponse, O>;
    },
    linkBankAccount: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof linkBankAccount>[0]['body'], requestOptions?: O): Promise<ApiResult<LinkBankAccountResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('linkBankAccount');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await linkBankAccount(opts as Parameters<typeof linkBankAccount>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<LinkBankAccountResponse, O>;
    },
    createNewMethod: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createNewMethod>[0]['body'], requestOptions?: O): Promise<ApiResult<CreateNewMethodResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createNewMethod');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createNewMethod(opts as Parameters<typeof createNewMethod>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreateNewMethodResponse, O>;
    },
    getAeropayStatus: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getAeropayStatus>[0]['body'], requestOptions?: O): Promise<ApiResult<GetAeropayStatusResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getAeropayStatus');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getAeropayStatus(opts as Parameters<typeof getAeropayStatus>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetAeropayStatusResponse, O>;
    },
    capture3DsPayment: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof capture3DsPayment>[0]['body'], requestOptions?: O): Promise<ApiResult<Capture3DsPaymentResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('capture3DsPayment');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await capture3DsPayment(opts as Parameters<typeof capture3DsPayment>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<Capture3DsPaymentResponse, O>;
    },
    getOffers: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getOffers>[0]['body'], requestOptions?: O): Promise<ApiResult<GetOffersResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getOffers');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getOffers(opts as Parameters<typeof getOffers>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetOffersResponse, O>;
    },
    updateInboxNotification: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof updateInboxNotification>[0]['body'], requestOptions?: O): Promise<ApiResult<UpdateInboxNotificationResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('updateInboxNotification');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await updateInboxNotification(opts as Parameters<typeof updateInboxNotification>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<UpdateInboxNotificationResponse, O>;
    },
    getInboxNotifications: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getInboxNotifications>[0]['body'], requestOptions?: O): Promise<ApiResult<GetInboxNotificationsResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getInboxNotifications');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getInboxNotifications(opts as Parameters<typeof getInboxNotifications>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetInboxNotificationsResponse, O>;
    },
    createAccountPaymentMethod: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createAccountPaymentMethod>[0]['body'], requestOptions?: O): Promise<ApiResult<CreateAccountPaymentMethodResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createAccountPaymentMethod');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createAccountPaymentMethod(opts as Parameters<typeof createAccountPaymentMethod>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreateAccountPaymentMethodResponse, O>;
    },
    createPayperPaymentMethod: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createPayperPaymentMethod>[0]['body'], requestOptions?: O): Promise<ApiResult<CreatePayperPaymentMethodResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createPayperPaymentMethod');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createPayperPaymentMethod(opts as Parameters<typeof createPayperPaymentMethod>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreatePayperPaymentMethodResponse, O>;
    },
    getPaymentMethods: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPaymentMethods>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPaymentMethodsResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPaymentMethods');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPaymentMethods(opts as Parameters<typeof getPaymentMethods>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPaymentMethodsResponse, O>;
    },
    getIframeSecurityData: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getIframeSecurityData>[0]['body'], requestOptions?: O): Promise<ApiResult<GetIframeSecurityDataResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getIframeSecurityData');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getIframeSecurityData(opts as Parameters<typeof getIframeSecurityData>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetIframeSecurityDataResponse, O>;
    },
    deletePaymentMethod: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof deletePaymentMethod>[0]['body'], requestOptions?: O): Promise<ApiResult<DeletePaymentMethodResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('deletePaymentMethod');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await deletePaymentMethod(opts as Parameters<typeof deletePaymentMethod>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<DeletePaymentMethodResponse, O>;
    },
    createOrder: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof createOrder>[0]['body'], requestOptions?: O): Promise<ApiResult<CreateOrderResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('createOrder');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await createOrder(opts as Parameters<typeof createOrder>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CreateOrderResponse, O>;
    },
    confirmOrder: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof confirmOrder>[0]['body'], requestOptions?: O): Promise<ApiResult<ConfirmOrderResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('confirmOrder');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await confirmOrder(opts as Parameters<typeof confirmOrder>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<ConfirmOrderResponse, O>;
    },
    refreshOrder: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof refreshOrder>[0]['body'], requestOptions?: O): Promise<ApiResult<RefreshOrderResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('refreshOrder');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await refreshOrder(opts as Parameters<typeof refreshOrder>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<RefreshOrderResponse, O>;
    },
    getPaymentOrder: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPaymentOrder>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPaymentOrderResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPaymentOrder');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPaymentOrder(opts as Parameters<typeof getPaymentOrder>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPaymentOrderResponse, O>;
    },
    getWithdrawMethods: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getWithdrawMethods>[0]['body'], requestOptions?: O): Promise<ApiResult<GetWithdrawMethodsResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getWithdrawMethods');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getWithdrawMethods(opts as Parameters<typeof getWithdrawMethods>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetWithdrawMethodsResponse, O>;
    },
    captureRedeemOption: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof captureRedeemOption>[0]['body'], requestOptions?: O): Promise<ApiResult<CaptureRedeemOptionResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('captureRedeemOption');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await captureRedeemOption(opts as Parameters<typeof captureRedeemOption>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CaptureRedeemOptionResponse, O>;
    },
    redeemMoney: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof redeemMoney>[0]['body'], requestOptions?: O): Promise<ApiResult<RedeemMoneyResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('redeemMoney');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await redeemMoney(opts as Parameters<typeof redeemMoney>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<RedeemMoneyResponse, O>;
    },
    cancelRedeemMoney: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof cancelRedeemMoney>[0]['body'], requestOptions?: O): Promise<ApiResult<CancelRedeemMoneyResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('cancelRedeemMoney');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await cancelRedeemMoney(opts as Parameters<typeof cancelRedeemMoney>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CancelRedeemMoneyResponse, O>;
    },
    cancelAllRedeemMoney: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof cancelAllRedeemMoney>[0]['body'], requestOptions?: O): Promise<ApiResult<CancelAllRedeemMoneyResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('cancelAllRedeemMoney');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await cancelAllRedeemMoney(opts as Parameters<typeof cancelAllRedeemMoney>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<CancelAllRedeemMoneyResponse, O>;
    },
    getRedeemMoneyHistory: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getRedeemMoneyHistory>[0]['body'], requestOptions?: O): Promise<ApiResult<GetRedeemMoneyHistoryResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getRedeemMoneyHistory');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getRedeemMoneyHistory(opts as Parameters<typeof getRedeemMoneyHistory>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetRedeemMoneyHistoryResponse, O>;
    },
    getRedeemHistory: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getRedeemHistory>[0]['body'], requestOptions?: O): Promise<ApiResult<GetRedeemHistoryResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getRedeemHistory');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getRedeemHistory(opts as Parameters<typeof getRedeemHistory>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetRedeemHistoryResponse, O>;
    },
    getWithdrawSettings: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getWithdrawSettings>[0]['body'], requestOptions?: O): Promise<ApiResult<GetWithdrawSettingsResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getWithdrawSettings');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getWithdrawSettings(opts as Parameters<typeof getWithdrawSettings>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetWithdrawSettingsResponse, O>;
    },
    getPendingRedeemCount: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPendingRedeemCount>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPendingRedeemCountResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPendingRedeemCount');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPendingRedeemCount(opts as Parameters<typeof getPendingRedeemCount>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPendingRedeemCountResponse, O>;
    },
    getCurrencyRate: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getCurrencyRate>[0]['body'], requestOptions?: O): Promise<ApiResult<GetCurrencyRateResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getCurrencyRate');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getCurrencyRate(opts as Parameters<typeof getCurrencyRate>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetCurrencyRateResponse, O>;
    },
    validateApplePayMerchant: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof validateApplePayMerchant>[0]['body'], requestOptions?: O): Promise<ApiResult<ValidateApplePayMerchantResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('validateApplePayMerchant');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await validateApplePayMerchant(opts as Parameters<typeof validateApplePayMerchant>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<ValidateApplePayMerchantResponse, O>;
    },
    tokenizeApplePay: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof tokenizeApplePay>[0]['body'], requestOptions?: O): Promise<ApiResult<TokenizeApplePayResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('tokenizeApplePay');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await tokenizeApplePay(opts as Parameters<typeof tokenizeApplePay>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<TokenizeApplePayResponse, O>;
    },
    tokenizeGooglePay: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof tokenizeGooglePay>[0]['body'], requestOptions?: O): Promise<ApiResult<TokenizeGooglePayResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('tokenizeGooglePay');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await tokenizeGooglePay(opts as Parameters<typeof tokenizeGooglePay>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<TokenizeGooglePayResponse, O>;
    },
    getPurchaseHistory: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPurchaseHistory>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPurchaseHistoryResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPurchaseHistory');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPurchaseHistory(opts as Parameters<typeof getPurchaseHistory>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPurchaseHistoryResponse, O>;
    },
    getRedeemsRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getRedeemsRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetRedeemsRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getRedeemsRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getRedeemsRequest(opts as Parameters<typeof getRedeemsRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetRedeemsRequestResponse, O>;
    },
    getTransactionLimitRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getTransactionLimitRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetTransactionLimitRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getTransactionLimitRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getTransactionLimitRequest(opts as Parameters<typeof getTransactionLimitRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetTransactionLimitRequestResponse, O>;
    },
    setPurchaseLimitRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof setPurchaseLimitRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<SetPurchaseLimitRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('setPurchaseLimitRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await setPurchaseLimitRequest(opts as Parameters<typeof setPurchaseLimitRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<SetPurchaseLimitRequestResponse, O>;
    },
    getPurchaseLimitRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof getPurchaseLimitRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<GetPurchaseLimitRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('getPurchaseLimitRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await getPurchaseLimitRequest(opts as Parameters<typeof getPurchaseLimitRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<GetPurchaseLimitRequestResponse, O>;
    },
    resetPaymentMethodsRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof resetPaymentMethodsRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<ResetPaymentMethodsRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('resetPaymentMethodsRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await resetPaymentMethodsRequest(opts as Parameters<typeof resetPaymentMethodsRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<ResetPaymentMethodsRequestResponse, O>;
    },
    resetPurchaseLimitRequest: async <O extends ApiRequestOptions | undefined>(requestBody: Parameters<typeof resetPurchaseLimitRequest>[0]['body'], requestOptions?: O): Promise<ApiResult<ResetPurchaseLimitRequestResponse, O>> => {
      const { headers: extHeaders, query: extQuery } = await resolveExtensionValues('resetPurchaseLimitRequest');
      const opts = buildRequestOpts(extHeaders, extQuery, requestBody, requestOptions);
      const result = await resetPurchaseLimitRequest(opts as Parameters<typeof resetPurchaseLimitRequest>[0]);
      maybeThrowOnError(result, requestOptions?.responseStyle);
      return mapResponse(result, requestOptions) as unknown as ApiResult<ResetPurchaseLimitRequestResponse, O>;
    },
  };
};

export type * from './client';
